import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Banner from 'app/components/Banner'
import { HeaderNotificationPropType } from './HeaderNotification.interface'

import './styles.scss'

const bc = 'header-notification-common'

const HeaderNotification: React.FC<HeaderNotificationPropType> = ({
  title = '',
  setTopNotificationBlockShown,
  children,
  additionalClosingAction,
  isWarning,
}) => {
  return (
    <>
      <Banner
        text={title}
        type="Default"
        className={cn(bc, { [`${bc}__warning`]: isWarning })}
        closable
        onClose={() => {
          setTopNotificationBlockShown && setTopNotificationBlockShown(false)
          additionalClosingAction && additionalClosingAction()
        }}
      >
        {children}
      </Banner>
    </>
  )
}

HeaderNotification.propTypes = {
  setTopNotificationBlockShown: PropTypes.func.isRequired,
  additionalClosingAction: PropTypes.func,
}

export default HeaderNotification
